import { render, staticRenderFns } from "./TreatmentHistory.vue?vue&type=template&id=b1372f64&scoped=true&"
import script from "./TreatmentHistory.vue?vue&type=script&lang=js&"
export * from "./TreatmentHistory.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentHistory.vue?vue&type=style&index=0&id=b1372f64&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1372f64",
  null
  
)

export default component.exports